let tabs, contents, tabName;

function openQuizTab(evt, selectedUuid) {
  // Убираем класс "active" у всех табов
  document.querySelectorAll(".quiz-steps__tab").forEach((tab) => {
    tab.classList.remove("active");
  });

  // Добавляем класс "active" к выбранному табу
  if (evt instanceof Event) {
    evt.currentTarget.classList.add("active");
  } else {
    evt.classList.add("active");
  }

  // Показываем элементы с соответствующим data-quiz-uuid и скрываем остальные
  document.querySelectorAll("[data-quiz-uuid]").forEach((element) => {
    if (element.dataset.quizUuid === selectedUuid) {
      element.style.display = "block";
    } else {
      element.style.display = "none";
    }
  });

  // показываем выбранное название и описание шага викторины
  document.querySelectorAll(".quiz-steps__tab-name").forEach((element) => {
    if (element.dataset.quizTabUuid === selectedUuid) {
      element.style.display = "block";
    } else {
      element.style.display = "none";
    }
  });
}

function initWorkQuizFirstTab() {
  const firstTab = tabs[0];
  const firstUuid = firstTab.dataset.quizTabUuid;

  firstTab.classList.add("active");
  contents.forEach((content) => {
    content.style.display =
      content.dataset.quizUuid === firstUuid ? "block" : "none";
  });

  tabName.forEach((content) => {
    content.style.display =
      content.dataset.quizTabUuid === firstUuid ? "block" : "none";
  });
}

function initWorkQuiz() {
  tabs = document.querySelectorAll(".quiz-steps__tab");
  contents = document.querySelectorAll("[data-quiz-uuid]");
  tabName = document.querySelectorAll(".quiz-steps__tab-name");

  // если пользователь находится не на странице викторин
  if (tabs.length == 0 && contents.length == 0 && tabName.length == 0) {
    return;
  }

  // Устанавливаем первый таб активным и отображаем его контент
  if (tabs.length > 0 && contents.length > 0) {
    initWorkQuizFirstTab()
  }

  // Добавляем обработчики клика для всех табов
  tabs.forEach((tab) => {
    tab.addEventListener("click", (evt) => {
      openQuizTab(evt, tab.dataset.quizTabUuid);
    });
  });

  const tabsContainer = document.querySelector(".quiz-steps__tabs");

  if (!tabsContainer) {
    return;
  }

  const tabsWrapper = document.querySelector(".quiz-steps__tabs-wrapper");
  const leftArrow = document.querySelector(".quiz-steps__arrow--left");
  const rightArrow = document.querySelector(".quiz-steps__arrow--right");

  let scrollPosition = 0;
  const tabWidth = 70; // Ширина одного таба + gap
  const visibleTabs = 5; // Количество видимых табов
  const maxScroll = tabsContainer.scrollWidth - tabsWrapper.offsetWidth;

  // Обновление состояния стрелок
  function updateArrows() {
    leftArrow.disabled = scrollPosition <= 0;
    rightArrow.disabled = scrollPosition >= maxScroll;
  }

  // Прокрутка влево
  leftArrow.addEventListener("click", () => {
    scrollPosition = Math.max(scrollPosition - tabWidth * visibleTabs, 0);
    tabsContainer.style.transform = `translateX(-${scrollPosition}px)`;
    updateArrows();
  });

  // Прокрутка вправо
  rightArrow.addEventListener("click", () => {
    scrollPosition = Math.min(
      scrollPosition + tabWidth * visibleTabs,
      maxScroll
    );
    tabsContainer.style.transform = `translateX(-${scrollPosition}px)`;
    updateArrows();
  });

  // Инициализация
  updateArrows();
}

export {initWorkQuiz, openQuizTab, initWorkQuizFirstTab};
